import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import FalhaPagamento from "../../../assets/kinologyIcons/svg/falha_pagamento.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import { FaturaProps } from "../../../interfaces/cartao.interface";
import { ActivityIndicator } from "../../../components/Buttons/FormSubmitButton/style";
import { TextsProps } from "../../../database/txt.interface";

// Constantes
const WHATSAPP_NUMBER = "556133479291";

// Interfaces
interface MensagemErro {
	titulo: string;
	subtitulo: string;
}

interface ErrosMap {
	[key: string]: MensagemErro;
}

// Mapa de erros


// Styles
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalFalhaPagamento: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	// Selectors
	const current_language:TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const is_open_falha_pagamento = useSelector(
		(state: any) => state.financial.modal_falha_pagamento
	);
	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;

	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);
	const errorPaymentWithCard = useSelector((state: any) => state.financial.set_error_payment_with_card);
	const payment_type: 'bank_slip' | 'pix' | 'card' | null = useSelector((state: any) => state.financial.payment_type);
	const load_change_payment_method = useSelector((state: any) => state.financial.load_change_payment_method);
	const faturas: FaturaProps[] = useSelector((state: any) => state.financial.faturas);

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_falha_pagamento(false, null));
	};

	const ERRO_MESSAGES: ErrosMap = {
		"51": {
			titulo: current_language?.saldo_insuficiente,
			subtitulo: current_language?.verificar_pagamento,
		},
		"62": {
			titulo: current_language?.Cartao_restricao,
			subtitulo:
				current_language?.contato_banco,
		},
		"14": {
			titulo: current_language?.cartao_invalido_2,
			subtitulo: current_language?.inserir_cartao_valido,
		},
		"05": {
			titulo: current_language?.negado_banco_emissor,
			subtitulo:
				current_language?.contato_banco,
		},
		"999": {
			titulo: current_language?.falha_processar_transacao,
			subtitulo:
				current_language?.contato_banco,
		},
		"58": {
			titulo: current_language?.erro_sistema_adquirente,
			subtitulo:
				current_language?.contato_banco,
		},
		"54": {
			titulo: current_language?.cartao_vencido,
			subtitulo: current_language?.inserir_cartao_valido,
		},
		"00": {
			titulo: current_language?.falha_pagamento,
			subtitulo:
				current_language?.contato_banco,
		},
		"": { titulo: current_language?.erro_boleto, subtitulo: "" },
	};

	type Method = "bank_slip" | "pix" | "card";
	const handleAlterPayment = (method: Method) => {
		dispatch(FinancialActions.alterar_forma_pagamento_request({
			SERVICO_SUPERLOGICA: config_servicos?.SERVICO_SUPERLOGICA,
			FORMA_PAGAMENTO: method,
			FATURAS: [faturas?.[faturas.length -1]?.ID_FATURA]
		}))
	}

	const handlePixPayment = () => {
		dispatch(FinancialActions.set_change_type_form_payment('pix'))
		dispatch(FinancialActions.set_load_change_payment_method(true))
		handleAlterPayment("pix");
	};

	const handleBoletoPayment = () => {
		dispatch(FinancialActions.set_change_type_form_payment('bank_slip'))
		dispatch(FinancialActions.set_load_change_payment_method(true))
		handleAlterPayment("bank_slip");
	};

	const handleCardPayment = () => {
		handleAlterPayment("card");
		dispatch(FinancialActions.set_modal_falha_pagamento(false, null));
		dispatch(FinancialActions.set_change_type_form_payment('card'))
		dispatch(FinancialActions.set_load_change_payment_method(true))
		dispatch(
			DashBoardActions.set_current_page("adicionar_pagamento")
		);

	};

	const handleContact = () => {
		window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
	};

	const mensagemErro = ERRO_MESSAGES[inadimplencia_motivo || ""] || ERRO_MESSAGES["00"];

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={is_open_falha_pagamento}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{ timeout: 500 }}
		>
			<Fade in={is_open_falha_pagamento}>
				<ModalContainer>
					<ModalContent>
						<IconContainer>
							<ModalIcon src={FalhaPagamento} alt="Ícone de falha no pagamento" />
						</IconContainer>
						<Title>{current_language?.falha_pagamento}</Title>
						<Title>{mensagemErro.titulo}</Title>
						<Message>{mensagemErro.subtitulo}</Message>
						<ButtonGroup>
							<Button onClick={() => handleCardPayment()} primary>{current_language?.tentar_novamente_cartao}</Button>
							<Button
								onClick={handlePixPayment}
								style={{display: errorPaymentWithCard ? 'none' : 'flex'}}
							>
								{ load_change_payment_method  &&  payment_type === 'pix'
									? <ActivityIndicator  style={{height: 18, width: 18}} />
									: current_language?.pagar_por_pix
								}
							</Button>
							<Button 
								onClick={handleBoletoPayment}
								style={{display: errorPaymentWithCard ? 'none' : 'flex'}}
							>
								{load_change_payment_method  &&  payment_type === 'bank_slip'
									? <ActivityIndicator  style={{height: 18, width: 18}} />
									: current_language?.pagar_por_boleto
								}
							</Button>
							<Button onClick={handleContact}>
								{
									current_language?.entrar_em_contato
								}
							</Button>
						</ButtonGroup>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	inset: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const IconContainer = styled.div`
	margin: 16px 0;
`;

const ModalIcon = styled.img`
	width: 4rem;
	height: 4rem;
`;

const Title = styled.h2`
	font-size: 18px;
	color: #002060;
	margin: 0 0 8px;
	font-weight: 600;
`;

const Message = styled.p`
	font-size: 14px;
	color: #002060;
	margin: 0 0 16px;
	line-height: 1.5;
`;

const ButtonGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

interface ButtonProps {
	primary?: boolean;
}

const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	background-color: ${({ primary }) => (primary ? "#009973" : "white")};
	color: ${({ primary }) => (primary ? "white" : "#009973")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #009973")};
	border-radius: 0.75rem;
	cursor: pointer;
	transition: all 0.2s ease-in-out;

	&:hover {
		background-color: ${({ primary }) => (primary ? "#008863" : "#f6f6f6")};
	}

	&:active {
		transform: scale(0.98);
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px rgba(0, 153, 115, 0.2);
	}
`;

export default ModalFalhaPagamento;
